import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';
import { UtilService } from 'app/_services/util.service';

class ProductUploadWizardComponentCtrl implements ng.IController {
    public wizardName: string;
    public rawDataId: number;
    public wizard: mgoAngularWizard.Wizard<any>;

    constructor(
        private WizardHandler: mgoAngularWizard.WizardHandler<any>,
        private utilService: UtilService
    ) {}

    $doCheck(): void {
        if (this.wizard) {
            return;
        }

        const wizard: mgoAngularWizard.Wizard<any> = this.WizardHandler.wizard(
            this.wizardName
        );

        if (wizard) {
            this.wizard = wizard;
            this.resetWizard();
        }
    }

    private resetWizard(): void {
        Object.keys(this.wizard.context).forEach(
            (key) => delete this.wizard.context[key]
        );
        this.wizard.context.data = {};
        this.wizard.context.data.wizardGuid = this.utilService.generateGuid();
    }
}

angular.module('app').component('pkpProductUploadWizard', {
    controller: ProductUploadWizardComponentCtrl,
    template:
        require('app/product-upload-wizard/product-upload-wizard.component.html'),
    bindings: {
        wizardName: '@',
        rawDataId: '<'
    }
});
